export default "__VITE_ASSET__DQlP1fuG__"